/** User level constants */
export enum USER_LEVEL {
	MATCHED = 'MATCHED',
	UNMATCHED = 'UNMATCHED',
	HUBBELL_ELIGIBLE = 'HUBBELL_ELIGIBLE',
	HUBBELL_NOT_ELIGIBLE = 'HUBBELL_NOT_ELIGIBLE',
	CATALENT_CLIENT = 'CATALENT_CLIENT',
}
